import { render, staticRenderFns } from "./ShipDetail.vue?vue&type=template&id=ecab3334&scoped=true"
import script from "./ShipDetail.vue?vue&type=script&lang=js"
export * from "./ShipDetail.vue?vue&type=script&lang=js"
import style0 from "./ShipDetail.vue?vue&type=style&index=0&id=ecab3334&prod&lang=scss&scoped=true"
import style1 from "./ShipDetail.vue?vue&type=style&index=1&id=ecab3334&prod&lang=scss&scoped=true"
import style2 from "./ShipDetail.vue?vue&type=style&index=2&id=ecab3334&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecab3334",
  null
  
)

export default component.exports